const r =
  window.requestIdleCallback ||
  function (n, e = {}) {
    const a = e.timeout || 1,
      t = performance.now();
    return setTimeout(function () {
      n({
        get didTimeout() {
          return e.timeout ? !1 : performance.now() - t - 1 > a;
        },
        timeRemaining: function () {
          return Math.max(0, 1 + (performance.now() - t));
        },
      });
    }, 1);
  };
export {r};
